import {ga4} from 'utils/ga4'
import {CLIENT_VERSION} from 'version'
import {RecaptchaFailureContext, RecaptchaFailureStage} from './types'

export const getErrorMessage = (error: unknown) => {
  return error instanceof Error ? error.message : String(error)
}

/**
 * Sends a reCAPTCHA loader or token-generation failure to GA4.
 *
 * API logs alone cannot explain why a client sent a null token, so the browser-side
 * reason has to reach central telemetry. Never include the generated token, the
 * checkout token, authorization headers, or customer data.
 */
export const reportRecaptchaFailure = (
  stage: RecaptchaFailureStage,
  error: unknown,
  context: RecaptchaFailureContext = {}
) => {
  ga4({
    event: 'recaptcha_failure',
    recaptcha: {
      stage,
      reason: getErrorMessage(error),
      action: context.action,
      request_attempt: context.requestAttempt,
      client_version: CLIENT_VERSION,
    },
  })
}
